import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["afterIcon", "allowIconLeading", "beforeIcon", "children", "color", "disabled", "fontSize", "fontWeight", "inline", "spacingSize", "textDecoration"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { clsx } from 'clsx';
import { useForkRef } from '@cian/react-utils';
import * as styles from './styles.module.css';
import { getTypographyComponent, InlineIconText, useLeadingIcon } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
const LinkComponent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      afterIcon,
      allowIconLeading = false,
      beforeIcon,
      children,
      color = 'default',
      disabled = false,
      fontSize = 'M',
      fontWeight = 'normal',
      inline = false,
      spacingSize = 'XS',
      textDecoration = 'none'
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const className = clsx(styles['link'], styles["spacing-size-".concat(spacingSize)], styles["font-size-".concat(fontSize)], styles["text-decoration-".concat(textDecoration)], styles[color], {
    [styles['disabled']]: disabled,
    [styles['no-content']]: !children,
    [styles['inline']]: inline
  });
  const {
    linkRef,
    beforeIconRef
  } = useLeadingIcon({
    allowIconLeading,
    beforeIcon,
    inline
  });
  const handleRef = useForkRef(ref, linkRef);
  const TypographyComponent = getTypographyComponent(fontSize, fontWeight);
  const beforeIconElement = beforeIcon && /*#__PURE__*/_jsx("span", {
    ref: beforeIconRef,
    className: styles['before-icon'],
    children: beforeIcon
  });
  const afterIconElement = afterIcon && /*#__PURE__*/_jsx("span", {
    className: styles['after-icon'],
    children: afterIcon
  });
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    ref: handleRef,
    className: className,
    rel: "noopener"
  }, rest), {}, {
    children: children ? /*#__PURE__*/_jsx(TypographyComponent, {
      as: "span",
      color: "current_color",
      display: "inline",
      children: /*#__PURE__*/_jsx(InlineIconText, {
        beforeIcon: beforeIconElement,
        afterIcon: afterIconElement,
        children: children
      })
    }) : beforeIcon
  }));
});
LinkComponent.displayName = 'Link';

/**
 * Компонент ссылки.
 *
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=52883-6480&t=dWJSsCGr4smKrzpW-4)
 */
export const Link = /*#__PURE__*/React.memo(LinkComponent);